/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RoleResponse
 */
export interface RoleResponse {
    /**
     *
     * @type {string}
     * @memberof RoleResponse
     */
    roleId?: string;
    /**
     *
     * @type {string}
     * @memberof RoleResponse
     */
    description?: string;
    /**
     * used to prevent certain Roles from being assigned to external (non JC staff) users (eg system permissions)
     * @type {boolean}
     * @memberof RoleResponse
     */
    blockForExternalUsers?: boolean;
    /**
     * True if the current user can edit this role. False for some built-in roles, and roles that don't belong to this user's org
     * @type {boolean}
     * @memberof RoleResponse
     */
    canEdit?: boolean;
    /**
     *
     * @type {string}
     * @memberof RoleResponse
     */
    assignmentRule?: RoleResponseAssignmentRuleEnum;
    /**
     *
     * @type {string}
     * @memberof RoleResponse
     */
    organisationId?: string;
    /**
     * The group ids this organisation belongs to (separated to avoid circular references).
     * @type {Array<string>}
     * @memberof RoleResponse
     */
    permissions?: Array<RoleResponsePermissionsEnum>;
}

/**
 * @export
 */
export const RoleResponseAssignmentRuleEnum = {
    Unknown: "Unknown",
    Any: "Any",
    InternalToInternal: "InternalToInternal",
    InternalToAny: "InternalToAny",
} as const;
export type RoleResponseAssignmentRuleEnum =
    (typeof RoleResponseAssignmentRuleEnum)[keyof typeof RoleResponseAssignmentRuleEnum];

/**
 * @export
 */
export const RoleResponsePermissionsEnum = {
    None: "none",
    DeviceLocationRead: "device_location_read",
    DeviceLocationUpdate: "device_location_update",
    DeviceConfigRead: "device_config_read",
    DeviceConfigUpdate: "device_config_update",
    DeviceReset: "device_reset",
    DeviceLogsRead: "device_logs_read",
    DeviceTasksRead: "device_tasks_read",
    DeviceTasksCreate: "device_tasks_create",
    DeviceEnergyUsageRead: "device_energy_usage_read",
    DeviceOperationalUpdate: "device_operational_update",
    DeviceFirmwareUpdate: "device_firmware_update",
    ChargeTransactionsRead: "charge_transactions_read",
    PowerMeterValuesRead: "power_meter_values_read",
    UserTasksRead: "user_tasks_read",
    EnterpriseUserAccountRead: "enterprise_user_account_read",
    EnterpriseUserAccountUpdate: "enterprise_user_account_update",
    EnterpriseUserAccountRoleUpdate: "enterprise_user_account_role_update",
    DeviceGroupManage: "device_group_manage",
    DeviceGroupCreate: "device_group_create",
    DeviceProvisioning: "device_provisioning",
    DevicePassthroughManage: "device_passthrough_manage",
    RfidTagsRead: "rfid_tags_read",
    RfidTagsManage: "rfid_tags_manage",
    RfidTagsDelete: "rfid_tags_delete",
    RoleCreate: "role_create",
    TicketingRead: "ticketing_read",
    TicketingCreate: "ticketing_create",
    PpmRead: "ppm_read",
    PpmManage: "ppm_manage",
    WebhookCreate: "webhook_create",
    NotificationPreferencesRead: "notification_preferences_read",
    NotificationPreferencesManage: "notification_preferences_manage",
    NotificationPreferencesManageOthers:
        "notification_preferences_manage_others",
    OrganisationPreferencesManage: "organisation_preferences_manage",
    MediaManage: "media_manage",
    DnspDashboard: "dnsp_dashboard",
    ProjectDashboard: "project_dashboard",
    GlobalDashboard: "global_dashboard",
    SystemDeviceProvisioning: "system_device_provisioning",
    SystemDeviceDeprovisioning: "system_device_deprovisioning",
    SystemDeviceAccessTagsUpdate: "system_device_access_tags_update",
    SystemDeviceServiceManage: "system_device_service_manage",
    SystemDeviceCatalogueUpdate: "system_device_catalogue_update",
    SystemOrganisation: "system_organisation",
    SystemUserAccountManage: "system_user_account_manage",
    SystemRfidTagsManage: "system_rfid_tags_manage",
    SystemPassthroughManage: "system_passthrough_manage",
    SystemServiceModelManage: "system_service_model_manage",
    SystemVehicleModelManage: "system_vehicle_model_manage",
    DevicePricingRead: "device_pricing_read",
    DevicePricingManage: "device_pricing_manage",
    DeviceDisplayPriceRead: "device_display_price_read",
    DeviceDisplayPriceManage: "device_display_price_manage",
    PartnerDeviceProvisioning: "partner_device_provisioning",
    PartnerOrganisationManage: "partner_organisation_manage",
    SystemE2eTestRunner: "system_e2e_test_runner",
} as const;
export type RoleResponsePermissionsEnum =
    (typeof RoleResponsePermissionsEnum)[keyof typeof RoleResponsePermissionsEnum];

/**
 * Check if a given object implements the RoleResponse interface.
 */
export function instanceOfRoleResponse(value: object): value is RoleResponse {
    return true;
}

export function RoleResponseFromJSON(json: any): RoleResponse {
    return RoleResponseFromJSONTyped(json, false);
}

export function RoleResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): RoleResponse {
    if (json == null) {
        return json;
    }
    return {
        roleId: json["roleId"] == null ? undefined : json["roleId"],
        description:
            json["description"] == null ? undefined : json["description"],
        blockForExternalUsers:
            json["blockForExternalUsers"] == null
                ? undefined
                : json["blockForExternalUsers"],
        canEdit: json["canEdit"] == null ? undefined : json["canEdit"],
        assignmentRule:
            json["assignmentRule"] == null ? undefined : json["assignmentRule"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        permissions:
            json["permissions"] == null ? undefined : json["permissions"],
    };
}

export function RoleResponseToJSON(value?: RoleResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        roleId: value["roleId"],
        description: value["description"],
        blockForExternalUsers: value["blockForExternalUsers"],
        canEdit: value["canEdit"],
        assignmentRule: value["assignmentRule"],
        organisationId: value["organisationId"],
        permissions: value["permissions"],
    };
}
